import { useEffect, useState } from "react";

// Componentes
import { Table, Card, CardBody, CardTitle } from "reactstrap";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../../../components/Paginationv3";
import ActionButtonRounded from "../../../../components/Buttons/ActionButtonRounded";
import DeleteButton from "../../../../components/Buttons/DeleteButton";

// Modais
import { ModalNewEventsXGroups } from "./modals/ModalNewEventsXGroups";
import { ModalEditEventsXGroups } from "./modals/ModalEditEventsXGroups";

// Services
import {
  fetchEventsXGroups,
  deleteEventsXGroups,
} from "../../../../utils/services/portalBoticario";
import { getGroups } from "../../../../utils/services/group";

const TAG_LABELS = {
  base: "Base de Cadastros",
  registered: "Cadastrados",
};

const EventsXGroups = (props) => {
  const location = useLocation();
  const token = props.state.global_user_data.data.token;
  const idEvent = location.state.idEvent;

  // state modais
  const [newModal, setNewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showSuccessDelete, setShowSuccessDelete] = useState(false);
  const [showErrorDelete, setShowErrorDelete] = useState(false);

  // state de dados
  const [allItems, setAllItems] = useState([]);
  const [itemEdit, setItemEdit] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [groupNames, setGroupNames] = useState({});

  // state de filtros
  const [searchGroup, setSearchGroup] = useState("");
  const [filterTag, setFilterTag] = useState("");

  // state de paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // carrega todos os vínculos do evento atual e os nomes dos grupos em paralelo
  const getEventsXGroups = async () => {
    try {
      const first = await fetchEventsXGroups(token, 1, 1, idEvent);
      const total = first.data.total || 0;

      const groupsRes = await getGroups({
        eventId: idEvent,
        offset: 1,
        limit: 1000,
        search: "",
      });
      const groupsData = groupsRes?.findOneGroupData?.data || [];
      const grpMap = {};
      groupsData.forEach((g) => {
        grpMap[g.id] = g.name;
      });
      setGroupNames(grpMap);

      if (total === 0) {
        setAllItems([]);
        return;
      }

      const result = await fetchEventsXGroups(token, 1, total, idEvent);
      setAllItems(result.data.items || []);
    } catch (error) {
      console.error("Erro ao buscar vínculos eventos x grupos:", error);
    }
  };

  useEffect(() => {
    getEventsXGroups();
  }, []);

  // abre o modal de edição com o item selecionado
  const handleEdit = (item) => {
    setItemEdit(item);
    setEditModal(true);
  };

  // abre a confirmação de exclusão com o item selecionado
  const handleDelete = (item) => {
    setItemToDelete(item);
    setConfirmDelete(true);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    date.setHours(date.getHours() - 3);
    return date.toLocaleString("pt-BR", {
      timeZone: "America/Fortaleza",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // aplica filtros client-side por nome do grupo e tag
  const filteredItems = allItems.filter((item) => {
    const groupName = groupNames[item.groupId] || "";
    if (searchGroup.trim() && !groupName.toLowerCase().includes(searchGroup.toLowerCase()))
      return false;
    if (filterTag && item.tag !== filterTag) return false;
    return true;
  });

  // fatia para a página atual
  const displayedItems = filteredItems.slice(
    (currentIndex - 1) * itemsPerPage,
    currentIndex * itemsPerPage
  );

  return (
    <>
      {/* Modais */}
      {newModal && (
        <ModalNewEventsXGroups
          isOpen={newModal}
          toggle={() => setNewModal(false)}
          jwt={token}
          refetch={getEventsXGroups}
          defaultEventId={idEvent}
        />
      )}

      {editModal && (
        <ModalEditEventsXGroups
          isOpen={editModal}
          toggle={() => setEditModal(false)}
          jwt={token}
          refetch={getEventsXGroups}
          itemData={itemEdit}
        />
      )}

      {/* Confirmação de exclusão */}
      {confirmDelete && (
        <SweetAlert
          title="Deseja deletar este vínculo?"
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={async () => {
            try {
              await deleteEventsXGroups(itemToDelete.id, token);
              await getEventsXGroups();
              setConfirmDelete(false);
              setShowSuccessDelete(true);
            } catch (error) {
              console.error("Erro ao deletar vínculo:", error);
              setConfirmDelete(false);
              setShowErrorDelete(true);
            }
          }}
          onCancel={() => setConfirmDelete(false)}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      )}

      {showSuccessDelete && (
        <SweetAlert
          title="Deletado!"
          success
          onConfirm={() => setShowSuccessDelete(false)}
        >
          Vínculo removido com sucesso!
        </SweetAlert>
      )}

      {showErrorDelete && (
        <SweetAlert
          title="Erro"
          error
          onConfirm={() => setShowErrorDelete(false)}
        >
          Não foi possível remover o vínculo. Tente novamente.
        </SweetAlert>
      )}

      <Card>
        <CardBody>
          <CardTitle>Eventos x Grupos</CardTitle>

          {/* Filtros e ações */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              flexWrap: "wrap",
              gap: 10,
              marginBottom: 16,
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, flex: 1 }}>
              <div>
                <label className="form-label" style={{ marginBottom: 4 }}>
                  Nome do grupo
                </label>
                <input
                  type="text"
                  className="form-control"
                  style={{ minWidth: 220 }}
                  placeholder="Buscar por nome do grupo"
                  value={searchGroup}
                  onChange={(e) => {
                    setSearchGroup(e.target.value);
                    setCurrentIndex(1);
                  }}
                />
              </div>

              <div>
                <label className="form-label" style={{ marginBottom: 4 }}>
                  Tag
                </label>
                <select
                  className="form-control"
                  style={{ minWidth: 180 }}
                  value={filterTag}
                  onChange={(e) => {
                    setFilterTag(e.target.value);
                    setCurrentIndex(1);
                  }}
                >
                  <option value="">Todas</option>
                  <option value="base">Base de Cadastros</option>
                  <option value="registered">Cadastrados</option>
                </select>
              </div>
            </div>

            <div className="header-btns-container">
              <ActionButtonRounded
                title="Novo Vínculo"
                onClick={() => setNewModal(true)}
              />
            </div>
          </div>

          {/* Tabela */}
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="thead-light">
                <tr>
                  <th>Grupo</th>
                  <th>Tag</th>
                  <th>Criado em</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {displayedItems.length === 0 ? (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center" }}>
                      Nenhum registro encontrado.
                    </td>
                  </tr>
                ) : (
                  displayedItems.map((item) => (
                    <tr key={item.id}>
                      <td style={{ maxWidth: 260 }}>
                        {groupNames[item.groupId] || item.groupId}
                      </td>
                      <td>{TAG_LABELS[item.tag] || item.tag}</td>
                      <td>{formatDate(item.createdAt)}</td>
                      <td>
                        <i
                          className="mdi mdi-pencil"
                          style={{
                            color: "green",
                            fontSize: 17,
                            cursor: "pointer",
                            marginRight: 8,
                          }}
                          onClick={() => handleEdit(item)}
                        />
                        <DeleteButton onClick={() => handleDelete(item)} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <Pagination
        data={displayedItems}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={filteredItems.length}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(EventsXGroups);
